import { c as _c } from "react/compiler-runtime";
import { ContactSlugEnum, CountryEnum, DateModeEnum, DatePicker, FormInput, FormSelect, getCountryData, getDate } from '@systemeio/ui';
import { contactFilterConditionTitles, contactFilterContactStateTitles, contactFilterDateConditionTitles, contactFilterTagConditionTitle } from 'modules/contacts/constants/contact-filter-titles';
import { ContactFilterConditionEnum, ContactFilterContactStateEnum, ContactFilterDateConditionEnum, ContactFilterTagConditionEnum, ContactSearchFieldEnum } from 'modules/contacts/enums/contact-enum';
import { ContactBulkData } from 'modules/contacts/types/contact-menu-interface';
import { useTagsAll } from 'modules/tags/hooks/use-tags-all';
import React, { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { getToday } from 'shared/utils/get-dates';
import { CloseIcon } from '@systemeio/ui/icons';
interface ContactFilterDefaultSearchProps {
  searchValue: string;
  length: number;
  index: number;
  deleteFilter: (slug: string, index: number) => void;
  onChangeSearchValue: (value: string) => void;
  slug: string;
  condition: ContactFilterConditionEnum | undefined;
  onChangeCondition: (data: ContactFilterConditionEnum) => void;
}
interface DefaultSearchDataInterface {
  id: ContactFilterConditionEnum;
  caption: ContactFilterConditionEnum;
}
export const ContactFilterDefaultSearch = t0 => {
  const $ = _c(30);
  const {
    searchValue,
    length,
    index,
    deleteFilter,
    onChangeSearchValue,
    slug,
    condition,
    onChangeCondition
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.values(ContactFilterConditionEnum);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t1.map(el => ({
      id: el,
      caption: t(contactFilterConditionTitles[el])
    }));
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== slug || $[4] !== t2) {
    t3 = t2.filter(el_0 => slug === ContactSlugEnum.Email ? el_0.id !== ContactFilterConditionEnum.not_set : true);
    $[3] = slug;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const defaultSearchData = t3;
  const t4 = `flex items-center justify-between gap-3 ${length > 1 && length - 1 !== index && "border-text-secondary/30 border-b pb-3"}`;
  let t5;
  if ($[6] !== onChangeCondition) {
    t5 = data => data && onChangeCondition(data);
    $[6] = onChangeCondition;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== condition || $[9] !== defaultSearchData || $[10] !== t5) {
    t6 = <FormSelect withoutCloseIcon={true} data={defaultSearchData} value={condition} onChange={t5} />;
    $[8] = condition;
    $[9] = defaultSearchData;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== condition || $[13] !== onChangeSearchValue || $[14] !== searchValue || $[15] !== slug || $[16] !== t) {
    t7 = slug === ContactSlugEnum.PhoneNumber ? <FormInput placeholder={t("dashboard.contacts.filter.enter_search_value")} value={searchValue} onChange={e => onChangeSearchValue(e.target.value)} disabled={condition === ContactFilterConditionEnum.not_set} /> : <FormInput placeholder={t("dashboard.contacts.filter.enter_search_value")} value={searchValue} onChange={e_0 => onChangeSearchValue(e_0.target.value)} disabled={condition === ContactFilterConditionEnum.not_set} />;
    $[12] = condition;
    $[13] = onChangeSearchValue;
    $[14] = searchValue;
    $[15] = slug;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className="flex w-full flex-col gap-3">{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== deleteFilter || $[22] !== index || $[23] !== length || $[24] !== slug) {
    t9 = length > 1 && <button type="button" className="group outline-hidden" onClick={e_1 => {
      e_1.preventDefault();
      deleteFilter(slug, index);
    }}><CloseIcon className="group-focus-visible:fill-text-primary fill-text-tertiary hover:fill-text-primary" /></button>;
    $[21] = deleteFilter;
    $[22] = index;
    $[23] = length;
    $[24] = slug;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t4 || $[27] !== t8 || $[28] !== t9) {
    t10 = <div className={t4}>{t8}{t9}</div>;
    $[26] = t4;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};
interface ContactFilterCountrySearchProps {
  length: number;
  index: number;
  deleteFilter: (slug: ContactSlugEnum | keyof typeof ContactSearchFieldEnum, index: number) => void;
  searchValue: CountryEnum | undefined;
  onChangeSearchValue: (value: CountryEnum | undefined) => void;
  slug: ContactSlugEnum.Country;
}
export const ContactFilterCountrySearch = t0 => {
  const $ = _c(20);
  const {
    length,
    index,
    deleteFilter,
    searchValue,
    onChangeSearchValue,
    slug
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const t1 = `flex items-center justify-between gap-3 ${length > 1 && length - 1 !== index && "border-text-secondary/30 border-b pb-3"}`;
  let t2;
  if ($[0] !== t) {
    t2 = t("dashboard.contacts.filter.choose_country");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = user?.dashboardLocale;
  let t4;
  if ($[2] !== t3) {
    t4 = getCountryData(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onChangeSearchValue) {
    t5 = data => onChangeSearchValue(data);
    $[4] = onChangeSearchValue;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== searchValue || $[7] !== t2 || $[8] !== t4 || $[9] !== t5) {
    t6 = <div className="flex w-full flex-col gap-3"><FormSelect key="country-filter" placeholder={t2} data={t4} value={searchValue} onChange={t5} /></div>;
    $[6] = searchValue;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== deleteFilter || $[12] !== index || $[13] !== length || $[14] !== slug) {
    t7 = length > 1 && <button type="button" onClick={e => {
      e.preventDefault();
      deleteFilter(slug, index);
    }}><CloseIcon /></button>;
    $[11] = deleteFilter;
    $[12] = index;
    $[13] = length;
    $[14] = slug;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className={t1}>{t6}{t7}</div>;
    $[16] = t1;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
interface ContactFilterTagSearchProps {
  length: number;
  index: number;
  deleteFilter: (slug: ContactSlugEnum | ContactSearchFieldEnum, index: number) => void;
  searchValue: number | undefined;
  onChangeSearchValue: (value: number | undefined) => void;
  slug: ContactSearchFieldEnum.tag;
  condition: ContactFilterTagConditionEnum | undefined;
  onChangeCondition: (data: ContactFilterTagConditionEnum) => void;
}
interface TagSearchDataInterface {
  id: ContactFilterTagConditionEnum;
  caption: ContactFilterTagConditionEnum;
}
export const ContactFilterTagSearch = t0 => {
  const $ = _c(35);
  const {
    length,
    index,
    deleteFilter,
    searchValue,
    onChangeSearchValue,
    slug,
    condition,
    onChangeCondition
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.values(ContactFilterTagConditionEnum);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t1.map(el => ({
      id: el,
      caption: t(contactFilterTagConditionTitle[el])
    }));
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const tagConditionData = t2;
  const {
    tags
  } = useTagsAll();
  const [tagData, setTagData] = useState(undefined);
  let t3;
  let t4;
  if ($[3] !== tags) {
    t3 = () => {
      if (tags) {
        setTagData(tags.items.map(_temp));
      }
    };
    t4 = [tags];
    $[3] = tags;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  const t5 = `flex items-center justify-between gap-3 ${length > 1 && length - 1 !== index && "border-text-secondary/30 border-b pb-3"}`;
  let t6;
  if ($[6] !== onChangeCondition) {
    t6 = data => data && onChangeCondition(data);
    $[6] = onChangeCondition;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== condition || $[9] !== t6 || $[10] !== tagConditionData) {
    t7 = <FormSelect withoutCloseIcon={true} data={tagConditionData} value={condition} onChange={t6} />;
    $[8] = condition;
    $[9] = t6;
    $[10] = tagConditionData;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = !tags;
  let t9;
  if ($[12] !== t) {
    t9 = t("dashboard.contacts.choose_tag");
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = condition === ContactFilterTagConditionEnum.without;
  let t11;
  if ($[14] !== onChangeSearchValue) {
    t11 = data_0 => onChangeSearchValue(data_0);
    $[14] = onChangeSearchValue;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== searchValue || $[17] !== t10 || $[18] !== t11 || $[19] !== t8 || $[20] !== t9 || $[21] !== tagData) {
    t12 = <FormSelect isPreFetching={t8} placeholder={t9} disabled={t10} data={tagData} value={searchValue} onChange={t11} />;
    $[16] = searchValue;
    $[17] = t10;
    $[18] = t11;
    $[19] = t8;
    $[20] = t9;
    $[21] = tagData;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t7) {
    t13 = <div className="flex w-full flex-col gap-3">{t7}{t12}</div>;
    $[23] = t12;
    $[24] = t7;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== deleteFilter || $[27] !== index || $[28] !== length || $[29] !== slug) {
    t14 = length > 1 && <button type="button" onClick={e => {
      e.preventDefault();
      deleteFilter(slug, index);
    }}><CloseIcon /></button>;
    $[26] = deleteFilter;
    $[27] = index;
    $[28] = length;
    $[29] = slug;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14 || $[33] !== t5) {
    t15 = <div className={t5}>{t13}{t14}</div>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t5;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
interface ContactFilterDateSearchProps {
  length: number;
  index: number;
  deleteFilter: (slug: ContactSlugEnum | ContactSearchFieldEnum, index: number) => void;
  searchValue: string | null;
  onChangeSearchValue: (value: string | null) => void;
  slug: ContactSearchFieldEnum.created_at;
  condition: ContactFilterDateConditionEnum | undefined;
  onChangeCondition: (data: ContactFilterDateConditionEnum) => void;
}
interface DateSearchDataInterface {
  id: ContactFilterDateConditionEnum;
  caption: ContactFilterDateConditionEnum;
}
export const ContactFilterDateSearch = t0 => {
  const $ = _c(37);
  const {
    length,
    index,
    deleteFilter,
    searchValue,
    onChangeSearchValue,
    slug,
    condition,
    onChangeCondition
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.values(ContactFilterDateConditionEnum);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t1.map(el => ({
      id: el,
      caption: t(contactFilterDateConditionTitles[el])
    }));
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const dateData = t2;
  const t3 = `flex items-center justify-between gap-3 ${length > 1 && length - 1 !== index && "border-text-secondary/30 border-b pb-3"}`;
  let t4;
  if ($[3] !== onChangeCondition) {
    t4 = data => data && onChangeCondition(data);
    $[3] = onChangeCondition;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== condition || $[6] !== dateData || $[7] !== t4) {
    t5 = <FormSelect withoutCloseIcon={true} data={dateData} value={condition} onChange={t4} />;
    $[5] = condition;
    $[6] = dateData;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = condition === ContactFilterDateConditionEnum.less_than ? DateModeEnum.DateTill : DateModeEnum.DateSince;
  const t7 = user?.timezone;
  let t8;
  if ($[9] !== t7) {
    t8 = getToday(t7);
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = user?.createdAt;
  const t10 = user?.timezone;
  let t11;
  if ($[11] !== t10 || $[12] !== t9) {
    t11 = getDate(t9, t10);
    $[11] = t10;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== onChangeSearchValue) {
    t12 = date => onChangeSearchValue(date);
    $[14] = onChangeSearchValue;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const t13 = user?.timezone;
  const t14 = user?.createdAt;
  let t15;
  if ($[16] !== intlLocale || $[17] !== searchValue || $[18] !== t11 || $[19] !== t12 || $[20] !== t13 || $[21] !== t14 || $[22] !== t6 || $[23] !== t8) {
    t15 = <DatePicker mode={t6} maxDate={t8} minDate={t11} value={searchValue} onChange={t12} timezone={t13} createdAt={t14} intlLocale={intlLocale} />;
    $[16] = intlLocale;
    $[17] = searchValue;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
    $[22] = t6;
    $[23] = t8;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t15 || $[26] !== t5) {
    t16 = <div className="flex w-full flex-col gap-3">{t5}{t15}</div>;
    $[25] = t15;
    $[26] = t5;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== deleteFilter || $[29] !== index || $[30] !== length || $[31] !== slug) {
    t17 = length > 1 && <button type="button" onClick={e => {
      e.preventDefault();
      deleteFilter(slug, index);
    }}><CloseIcon /></button>;
    $[28] = deleteFilter;
    $[29] = index;
    $[30] = length;
    $[31] = slug;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16 || $[34] !== t17 || $[35] !== t3) {
    t18 = <div className={t3}>{t16}{t17}</div>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t3;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
};
interface ContactFilterEmailActivitySearchProps {
  length: number;
  index: number;
  deleteFilter: (slug: keyof typeof ContactSlugEnum | ContactSearchFieldEnum, index: number) => void;
  searchValue: string | null;
  onChangeSearchValue: (value: string | null) => void;
  slug: ContactSearchFieldEnum.last_activity_date;
}
export const ContactFilterEmailActivitySearch = t0 => {
  const $ = _c(30);
  const {
    length,
    index,
    deleteFilter,
    searchValue,
    onChangeSearchValue,
    slug
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const t1 = `flex items-center justify-between gap-3 ${length > 1 && length - 1 !== index && "border-text-secondary/30 border-b pb-3"}`;
  const t2 = user?.timezone;
  let t3;
  if ($[0] !== t2) {
    t3 = getToday(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = user?.createdAt;
  const t5 = user?.timezone;
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = getDate(t4, t5);
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t) {
    t7 = t("global.select_date");
    $[5] = t;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t) {
    t8 = t("dashboard.contacts.filter.state_no_activity_since");
    $[7] = t;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== onChangeSearchValue) {
    t9 = date => onChangeSearchValue(date);
    $[9] = onChangeSearchValue;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = user?.timezone;
  const t11 = user?.createdAt;
  let t12;
  if ($[11] !== intlLocale || $[12] !== searchValue || $[13] !== t10 || $[14] !== t11 || $[15] !== t3 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t12 = <div className="flex w-full flex-col gap-3"><DatePicker maxDate={t3} minDate={t6} placeholder={t7} label={t8} value={searchValue} onChange={t9} timezone={t10} createdAt={t11} intlLocale={intlLocale} /></div>;
    $[11] = intlLocale;
    $[12] = searchValue;
    $[13] = t10;
    $[14] = t11;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== deleteFilter || $[22] !== index || $[23] !== length || $[24] !== slug) {
    t13 = length > 1 && <button type="button" onClick={e => {
      e.preventDefault();
      deleteFilter(slug, index);
    }}><CloseIcon /></button>;
    $[21] = deleteFilter;
    $[22] = index;
    $[23] = length;
    $[24] = slug;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t1 || $[27] !== t12 || $[28] !== t13) {
    t14 = <div className={t1}>{t12}{t13}</div>;
    $[26] = t1;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
interface ContactFilterContactStateSearchProps {
  length: number;
  index: number;
  deleteFilter: (slug: ContactSlugEnum | ContactSearchFieldEnum, index: number) => void;
  slug: ContactSearchFieldEnum.state;
  condition: ContactFilterContactStateEnum | undefined;
  onChangeCondition: (data?: ContactFilterContactStateEnum) => void;
}
interface ContactStateSearchDataInterface {
  id: ContactFilterContactStateEnum;
  caption: ContactFilterContactStateEnum;
}
export const ContactFilterContactStateSearch = t0 => {
  const $ = _c(18);
  const {
    index,
    length,
    deleteFilter,
    slug,
    condition,
    onChangeCondition
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.values(ContactFilterContactStateEnum);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t1.map(el => ({
      id: el,
      caption: t(contactFilterContactStateTitles[el])
    }));
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const contactStateData = t2;
  const t3 = `flex items-center justify-between gap-3 ${length > 1 && length - 1 !== index && "border-text-secondary/30 border-b pb-3"}`;
  let t4;
  if ($[3] !== onChangeCondition) {
    t4 = date => onChangeCondition(date);
    $[3] = onChangeCondition;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== condition || $[6] !== contactStateData || $[7] !== t4) {
    t5 = <div className="flex w-full flex-col gap-3"><FormSelect withoutCloseIcon={true} data={contactStateData} value={condition} onChange={t4} /></div>;
    $[5] = condition;
    $[6] = contactStateData;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== deleteFilter || $[10] !== index || $[11] !== length || $[12] !== slug) {
    t6 = length > 1 && <button type="button" onClick={e => {
      e.preventDefault();
      deleteFilter(slug, index);
    }}><CloseIcon /></button>;
    $[9] = deleteFilter;
    $[10] = index;
    $[11] = length;
    $[12] = slug;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className={t3}>{t5}{t6}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
interface ContactFilterAffiliateSearchProps {
  length: number;
  index: number;
  deleteFilter: (slug: keyof typeof ContactSlugEnum | ContactSearchFieldEnum, index: number) => void;
  slug: ContactSearchFieldEnum.affiliate;
  searchValue: string;
  onChangeSearchValue: (value: string) => void;
}
export const ContactFilterAffiliateSearch = t0 => {
  const $ = _c(17);
  const {
    length,
    index,
    deleteFilter,
    slug,
    searchValue,
    onChangeSearchValue
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = `flex items-center justify-between gap-3 ${length > 1 && length - 1 !== index && "border-text-secondary/30 border-b pb-3"}`;
  let t2;
  if ($[0] !== t) {
    t2 = t("dashboard.contacts.filter.affiliate_id_or_email");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onChangeSearchValue) {
    t3 = e => onChangeSearchValue(e.target.value);
    $[2] = onChangeSearchValue;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== searchValue || $[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex w-full flex-col gap-3"><FormInput placeholder={t2} value={searchValue} onChange={t3} /></div>;
    $[4] = searchValue;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== deleteFilter || $[9] !== index || $[10] !== length || $[11] !== slug) {
    t5 = length > 1 && <button type="button" onClick={e_0 => {
      e_0.preventDefault();
      deleteFilter(slug, index);
    }}><CloseIcon /></button>;
    $[8] = deleteFilter;
    $[9] = index;
    $[10] = length;
    $[11] = slug;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t1 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className={t1}>{t4}{t5}</div>;
    $[13] = t1;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
function _temp(el_0) {
  return {
    id: el_0.id,
    caption: el_0.name
  };
}